import { IApiRequestConfig } from '../api.types';

export const switchTenantApi = (id: string): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'switchTenant',
  uri: 'json',
  action: 'switch-tenant',
  method: 'post',
  data: { id },
  v2: true,
});

export const searchUserTenantsApi = (): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'searchUserTenants',
  uri: 'json',
  action: 'tenants',
  method: 'get',
  v2: true,
});

export const addUserToTenantApi = (id: string): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'addUserToTenant',
  uri: 'json',
  action: `tenants/add-user`,
  method: 'post',
  data: { id },
  v2: true,
});

export const createTenantApi = (data: any): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'createTenant',
  uri: 'json',
  action: 'tenants',
  method: 'post',
  data,
  v2: true,
});
